import React, { useState } from 'react';
import { faqs } from '../mock';
import { ChevronDown, HelpCircle } from 'lucide-react';

const FAQ = () => {
  const [openId, setOpenId] = useState(null);

  const toggleFAQ = (id) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <div className="min-h-screen bg-gray-50 pt-20">
      {/* Header */}
      <section className="bg-gradient-to-br from-[#001F3F] to-[#003366] text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-center mb-6">
            <HelpCircle size={48} />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center">Sık Sorulan Sorular</h1>
          <p className="text-xl text-white/90 max-w-3xl mx-auto text-center">
            Merak ettiğiniz soruların yanıtlarını burada bulabilirsiniz.
          </p>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-4">
            {faqs.map((faq) => (
              <div 
                key={faq.id}
                className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300"
              >
                <button
                  onClick={() => toggleFAQ(faq.id)}
                  className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors"
                >
                  <span className="text-lg font-semibold text-[#001F3F] pr-4">{faq.question}</span>
                  <ChevronDown 
                    size={24} 
                    className={`text-[#001F3F] flex-shrink-0 transition-transform duration-300 ${
                      openId === faq.id ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                <div 
                  className={`overflow-hidden transition-all duration-300 ${
                    openId === faq.id ? 'max-h-96' : 'max-h-0'
                  }`}
                >
                  <div className="px-6 py-5 bg-gray-50 border-t border-gray-200">
                    <p className="text-gray-700 leading-relaxed">{faq.answer}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-[#001F3F] mb-4">
            Sorunuza Yanıt Bulamadınız mı?
          </h2>
          <p className="text-lg text-gray-700 mb-8">
            Bizimle iletişime geçin, size yardımcı olmaktan mutluluk duyarız.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => window.location.href = '/iletisim'}
              className="bg-[#001F3F] hover:bg-[#003366] text-white px-8 py-3 rounded-lg font-semibold transition-all duration-300 hover:scale-105 shadow-lg"
            >
              İletişim Formu
            </button>
            <button
              onClick={() => window.open('https://wa.me/905372101452', '_blank')}
              className="bg-[#25D366] hover:bg-[#20BA5A] text-white px-8 py-3 rounded-lg font-semibold transition-all duration-300 hover:scale-105 shadow-lg"
            >
              WhatsApp ile Yaz
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;